import React from 'react';
import PopupCopyInspection from '../PopupCopyInspection';
import ButtonDownloadFiles from '../ButtonDownloadFiles';
import ButtonRedirect from '../ButtonRedirect';
import ButtonDetails from '../ButtonDetails';
import ButtonPreview from '../ButtonPreview';
import ButtonDD from "../../../_common/components/ButtonDD";
import {PopupCopyInspectionProvider} from '../PopupCopyInspectionContext';
import {DecisionTreeShumaTypesOptionsContextProvider} from '../../../_common/components/DecisionTreeOptions';
import PopupNotes from "../PopupNotes";
import {PopupNotesContextProvider} from "../PopupNotes/contexts/PopupNotesContext";

const Actions = ({data, isRow}) => {
  return (
    <div className={isRow ? 'd-flex justify-content-between align-items-center' : ''}>
      <ButtonPreview data={data}/>
      {isRow && <div className={'mx-2'}/>}
      <ButtonDetails shumaID={data.shumaID} firmShumaID={data.firmShumaID}/>
      {isRow && <div className={'mx-2'}/>}
      <ButtonRedirect data={data}/>
      {isRow && <div className={'mx-2'}/>}
      <DecisionTreeShumaTypesOptionsContextProvider shumaID={data.shumaID}>
        <PopupCopyInspectionProvider shumaReasonID={data.shumaReasonID}>
          <PopupCopyInspection data={data}/>
        </PopupCopyInspectionProvider>
      </DecisionTreeShumaTypesOptionsContextProvider>
      {isRow && <div className={'mx-2'}/>}
      <ButtonDownloadFiles shumaID={data.shumaID} firmShumaID={data.firmShumaID}/>
      {isRow && <div className={'mx-2'}/>}
      <PopupNotesContextProvider shumaID={data?.shumaID}>
        <PopupNotes firmShumaID={data?.firmShumaID}/>
      </PopupNotesContextProvider>
    </div>
  );
};

export function ActionsColumnFormatter(data, columnsMode) {

  return columnsMode
    ? <div className="d-flex align-items-center">
      <ButtonDD
        menuPosition={'left'}
        items={[{
          itemContent: <Actions data={data} isRow={true}/>
        }]}
      />
    </div>
    : <Actions data={data}/>;
}